import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class OfflineResMgr extends Base {
  // 获取线上资源列表
  public static getOfflineResList(option, page) {
    const param = {
      classify: option.classifyValue,
      pid: option.pid,
      serialNumber: option.serialNumber,
      deviceType: option.deviceType,
      status: option.statusValue,
      provinceId: option.vprovinceValue,
      manufacturer: option.manufacturerValue,
      currPage: page.currPage,
      pageSize: page.size
    };
    return request.get(`/api/resource/offline/list`, {
      params: param
    });
  }
  // 获取调拨列表接口
  public static getTransfeList(id: string) {
    return request.get(`/api/transfer/resourceTransferInfo`,
    {
      params: {
        resourceId: id
      }
    });
  }
}
